import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useMemo, useRef, useState, useEffect } from 'react';
import { View, Text as RNText, Pressable, Animated, Easing, Dimensions, PanResponder, Platform } from 'react-native';
import DomParser from 'dom-parser';
import sanitizeHtml from 'sanitize-html';
import { parseDocument } from 'htmlparser2';
import { findOne, replaceElement, compareDocumentPosition, getOuterHTML } from 'domutils';
import { Element } from 'domhandler';
import FailToLoad from '../../../assets/images/rn/FailToLoad';
import LoadingCircle from '../../../assets/images/rn/LoadingCircle';
import * as RNStyle from '../../../styles/rn';
import defaultOptions from '../../../constants/sanitizeHtmlOptions';
import { getPrefixCls } from '../../../utils/getPrefixCls';
import { Title } from '../../Title/rn';
import { Text } from '../../Text/rn';
import { Button } from '../../Button/rn';
import { VIEW_ARTICLE_TEXT, richTextTouchEndDebounceTime } from '../../../utils/constants';
import { useLocale } from '../../LocaleProvider/rn';
import { useComponentTracking, useTracking, emitTrackingEvent } from '../../../hooks/rn/useTracking';
import { TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '../../../utils/tracking/constants';
import { MaskType, RichText } from '../../RichText/rn';
import { getScaledPx } from '../../../utils/rn/tools';
import { Popup } from '../../Popup/rn';
import { RichTextInWebView } from '../../RichText/rn/RichTextInWebView';
import ArrowDown from '../../../assets/images/rn/KeyAnswerArrow';
import { BubbleInnerWidth } from '../../../styles/rn';
import UiOptimisationRecommenderRightArrow from '../../../assets/images/rn/UiOptimisationRecommenderRightArrow';
import { formatHtml, processAccordionBlock, checkHaveTable } from '../../../utils/tools';
import { debounce } from '../../../utils/lodashReplacement';
import styles from './styles';
import { PopupArticle } from './PopupArticle';
export var ArticleStatus;
(function (ArticleStatus) {
  ArticleStatus["LOADING"] = "LOADING";
  ArticleStatus["DELETED"] = "DELETED";
  ArticleStatus["ERROR"] = "ERROR";
  ArticleStatus["FINISH"] = "FINISH";
})(ArticleStatus || (ArticleStatus = {}));
var ARTICLE_TRACKER_SCOPE = 'article_scope';
var FAQList = function FAQList(props) {
  var PREFIX = props.PREFIX,
    faqTitle = props.faqTitle,
    faqIntentList = props.faqIntentList,
    onClickFaq = props.onClickFaq,
    disabledFaq = props.disabledFaq,
    _props$styles = props.styles,
    stylesProps = _props$styles === void 0 ? {} : _props$styles,
    isUIOptimisationRecommender = props.isUIOptimisationRecommender,
    isUIOptimisationTableStyle = props.isUIOptimisationTableStyle;
  var renderFAQItem = function renderFAQItem(faq, index) {
    var _useTracking = useTracking({
        trackingData: props.trackingData,
        componentData: _objectSpread(_objectSpread({}, faq), {}, {
          location: index
        }),
        scope: ARTICLE_TRACKER_SCOPE
      }),
      trackingClick = _useTracking.trackingClick,
      trackingImpressionProps = _useTracking.trackingImpressionProps;
    var textRender = /*#__PURE__*/React.createElement(RNText, {
      numberOfLines: 2,
      ellipsizeMode: "tail",
      style: [styles["".concat(PREFIX, "-faq-item")], disabledFaq && styles["".concat(PREFIX, "-faq-item__disabled")], isUIOptimisationRecommender ? styles["".concat(PREFIX, "-faq-item-ui-optimisation-recommender")] : {}]
    }, faq.text);
    return /*#__PURE__*/React.createElement(Pressable, _extends({
      onPress: function onPress() {
        // trackingClick && tracker.click(trackingClick);
        onClickFaq === null || onClickFaq === void 0 ? void 0 : onClickFaq(faq, {
          trackingData: trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data
        });
      }
    }, trackingImpressionProps), isUIOptimisationRecommender ? /*#__PURE__*/React.createElement(View, {
      style: styles["".concat(PREFIX, "-faq-item-container-ui-optimisation-recommender")]
    }, textRender, /*#__PURE__*/React.createElement(UiOptimisationRecommenderRightArrow, {
      style: styles["".concat(PREFIX, "-faq-item-icon-ui-optimisation-recommender")]
    })) : textRender);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, faqIntentList !== null && faqIntentList !== void 0 && faqIntentList.length ? /*#__PURE__*/React.createElement(View, {
    style: [styles["".concat(PREFIX, "-faq-container")], stylesProps, isUIOptimisationRecommender ? styles["".concat(PREFIX, "-faq-container-ui-optimisation-recommender")] : {}, isUIOptimisationTableStyle ? styles["".concat(PREFIX, "-faq-container-ui-optimisation-table")] : {}]
  }, faqTitle && /*#__PURE__*/React.createElement(View, {
    style: isUIOptimisationRecommender ? styles["".concat(PREFIX, "-faq-title-container-ui-optimisation-recommender")] : {}
  }, /*#__PURE__*/React.createElement(RNText, {
    numberOfLines: 2,
    ellipsizeMode: "tail",
    style: [styles["".concat(PREFIX, "-faq-title")], isUIOptimisationRecommender ? styles["".concat(PREFIX, "-faq-title-ui-optimisation-recommender")] : {}]
  }, faqTitle)), /*#__PURE__*/React.createElement(View, null, faqIntentList.map(renderFAQItem))) : null);
};
var linearGradientHeight = 40;
export var MAX_ACCORDION_ITEMS_IN_PREVIEW = 3;
var domParser = new DomParser();
export var Article = function Article(props) {
  var _componentTrackingDat, _props$componentTrack;
  var PREFIX = 'article';
  var content = props.content,
    _props$status = props.status,
    status = _props$status === void 0 ? ArticleStatus.FINISH : _props$status,
    _props$failToLoadText = props.failToLoadText,
    failToLoadText = _props$failToLoadText === void 0 ? '' : _props$failToLoadText,
    _props$reloadText = props.reloadText,
    reloadText = _props$reloadText === void 0 ? '' : _props$reloadText,
    _props$articleDeleted = props.articleDeletedText,
    articleDeletedText = _props$articleDeleted === void 0 ? '' : _props$articleDeleted,
    showButtonText = props.showButtonText,
    closeButtonText = props.closeButtonText,
    componentTrackingData = props.componentTrackingData,
    articleContentTrackingData = props.articleContentTrackingData,
    disableSpecialLink = props.disableSpecialLink,
    _props$autoPopup = props.autoPopup,
    autoPopup = _props$autoPopup === void 0 ? false : _props$autoPopup,
    showExpandIcon = props.showExpandIcon,
    richTextSize = props.richTextSize,
    _onWebViewSizeChange = props.onWebViewSizeChange,
    title = props.title,
    onButtonClick = props.onButtonClick,
    _props$showArticle = props.showArticle,
    showArticleByCaller = _props$showArticle === void 0 ? false : _props$showArticle,
    currentDisplayedTitle = props.currentDisplayedTitle,
    currentDisplayedContent = props.currentDisplayedContent,
    onArticleClose = props.onArticleClose,
    _props$controlShowArt = props.controlShowArticle,
    controlShowArticle = _props$controlShowArt === void 0 ? false : _props$controlShowArt,
    _props$isSeparate = props.isSeparate,
    isSeparate = _props$isSeparate === void 0 ? false : _props$isSeparate,
    _props$isScrollToUnre = props.isScrollToUnread,
    isScrollToUnread = _props$isScrollToUnre === void 0 ? false : _props$isScrollToUnre,
    unreadText = props.unreadText,
    viewMoreText = props.viewMoreText,
    _props$summaryMaxHeig = props.summaryMaxHeight,
    summaryMaxHeight = _props$summaryMaxHeig === void 0 ? 400 : _props$summaryMaxHeig,
    faqTitle = props.faqTitle,
    faqIntentList = props.faqIntentList,
    disabledFaq = props.disabledFaq,
    isOldUI = props.isOldUI,
    needPopup = props.needPopup,
    onExceededMaxHeightChange = props.onExceededMaxHeightChange,
    webViewKey = props.webViewKey,
    isUIOptimisationRecommender = props.isUIOptimisationRecommender,
    isUIOptimisationButton = props.isUIOptimisationButton,
    _props$isUIOptimisati = props.isUIOptimisationAccordion,
    isUIOptimisationAccordion = _props$isUIOptimisati === void 0 ? false : _props$isUIOptimisati,
    isUIOptimisationTable = props.isUIOptimisationTable,
    haveMinRichTextWidth = props.haveMinRichTextWidth;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    exceededMaxHeight = _useState2[0],
    setExceededMaxHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollHeight = _useState4[0],
    setScrollHeight = _useState4[1]; // 最终需要滚动的高度

  var _useState5 = useState({
      index: 0,
      text: unreadText
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    unreadObj = _useState6[0],
    setUnreadObj = _useState6[1];
  var isUIOptimisationTableStyle = isUIOptimisationTable && checkHaveTable(content);
  var PopupArticlePaddingHorizontal = isUIOptimisationTableStyle ? 0 : getScaledPx(24); // new ui 控制 popup

  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showPopup = _useState8[0],
    setShowPopup = _useState8[1]; // old ui 控制 popup

  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showArticle = _useState10[0],
    setShowArticle = _useState10[1];
  var scrollViewRef = useRef(null);
  var scrollY = useRef(new Animated.Value(0)).current;
  var trackClosePopupRef = useRef({
    startTime: new Date(),
    articleScrolls: 0,
    articleScrollToEnd: false
  });
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isFirstImage = _useState12[0],
    setIsFirstImage = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showGradientForAccordion = _useState14[0],
    setShowGradientForAccordion = _useState14[1];
  var _useState15 = useState([-1, -1]),
    _useState16 = _slicedToArray(_useState15, 2),
    defaultAccordionIndexInfo = _useState16[0],
    setDefaultAccordionIndexInfo = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    accordionOffsetTop = _useState18[0],
    setAccordionOffsetTop = _useState18[1];
  var _useState19 = useState(true),
    _useState20 = _slicedToArray(_useState19, 2),
    scrollEnabled = _useState20[0],
    setScrollEnabled = _useState20[1]; // const handleDisabledScroll = debounce(
  //   () => {
  //     setScrollEnabled(false);
  //   },
  //   100,
  //   { leading: true }
  // );

  var handleDisabledScroll = function handleDisabledScroll() {
    setScrollEnabled(false);
  };
  var handleRichTextTouchEnd = debounce(function () {
    setScrollEnabled(true);
  }, richTextTouchEndDebounceTime);
  var panResponder = useRef(PanResponder.create({
    // 处理开始滑动事件
    onStartShouldSetPanResponder: function onStartShouldSetPanResponder() {
      return true;
    },
    // 处理滑动事件
    onMoveShouldSetPanResponder: function onMoveShouldSetPanResponder(_, gestureState) {
      // 判断滑动方向是否为横向
      var isHorizontalSwipe = Math.abs(gestureState.dx) > Math.abs(gestureState.dy); // 如果是横向滑动，则禁止父级ScrollView的垂直滚动

      if (isHorizontalSwipe) {
        handleDisabledScroll();
        return true;
      } else {
        return false;
      }
    }
  })).current; // const scrollViewData = useRef({
  //   startX: 0,
  //   startY: 0,
  //   scrollEnabled: true,
  // });
  // const onScrollViewTouchStart = (e: GestureResponderEvent) => {
  //   scrollViewData.current = {
  //     ...scrollViewData.current,
  //     startX: e.nativeEvent.pageX,
  //     startY: e.nativeEvent.pageY,
  //   };
  // };
  // const onScrollViewTouchMove = (e: GestureResponderEvent) => {
  //   if (scrollViewData.current.scrollEnabled) {
  //     const offsetX = e.nativeEvent.pageX - scrollViewData.current.startX;
  //     const offsetY = e.nativeEvent.pageY - scrollViewData.current.startY;
  //     if (Math.abs(offsetX) > Math.abs(offsetY)) {
  //       setScrollEnabled(false);
  //       scrollViewData.current.scrollEnabled = false;
  //     }
  //   }
  // };
  // const onScrollViewTouchEnd = () => {
  //   setTimeout(() => {
  //     setScrollEnabled(true);
  //     scrollViewData.current = {
  //       startX: 0,
  //       startY: 0,
  //       scrollEnabled: true,
  //     };
  //   }, 50);
  // };

  var changeTrackClosePopupData = function changeTrackClosePopupData(data) {
    var oldTrackingData = trackClosePopupRef.current;
    trackClosePopupRef.current = _objectSpread(_objectSpread({}, oldTrackingData || {}), data || {});
  };
  var _useComponentTracking = useComponentTracking(props),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    articleTracking = _useComponentTracking2.article,
    reloadTracking = _useComponentTracking2.reload,
    deleteTracking = _useComponentTracking2.delete;
  var rotateAnimate = useRef(new Animated.Value(0)).current;
  var rotateInterpolation = rotateAnimate.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg']
  });
  var trackCloseArticleContentDataRef = useRef({
    startTime: new Date(),
    articleScrolls: 0,
    tableScrolls: 0,
    articleScrollToEnd: false
  });
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var changeTrackCloseArticleContentData = function changeTrackCloseArticleContentData(data) {
    var trackCloseArticleContentData = trackCloseArticleContentDataRef.current;
    trackCloseArticleContentDataRef.current = _objectSpread(_objectSpread({}, trackCloseArticleContentData), data);
  }; // 补充上报数据

  if (componentTrackingData !== null && componentTrackingData !== void 0 && (_componentTrackingDat = componentTrackingData.article) !== null && _componentTrackingDat !== void 0 && _componentTrackingDat.trackingdataBasic) {
    componentTrackingData.article.trackingdataBasic.button_text = showButtonText || trans(VIEW_ARTICLE_TEXT);
  }
  var getParsedDom = function getParsedDom() {
    var realContent = content.replace(/&amp;/g, '&');
    return domParser.parseFromString("<div id=\"".concat(getPrefixCls('article-content'), "\">").concat(realContent, "</div>"));
  };
  var getArticleRealText = function getArticleRealText() {
    var _dom$getElementById;
    var dom = getParsedDom();
    var realText = '';
    (_dom$getElementById = dom.getElementById(getPrefixCls('article-content'))) === null || _dom$getElementById === void 0 ? void 0 : _dom$getElementById.childNodes.forEach(function (node) {
      if (node.nodeName === 'p') {
        realText += node.textContent;
      }
    });
    return realText;
  };
  var getArticleFirstElement = function getArticleFirstElement() {
    var sanitizeContent = processAccordionBlock(formatHtml(sanitizeHtml(content, defaultOptions)), {
      isUIOptimisationAccordion: isUIOptimisationAccordion
    });
    var container = "<div>".concat(sanitizeContent, "</div>");
    var dom = parseDocument(container);
    var firstAccordion = findOne(function (element) {
      return element.name === 'accordion-block';
    }, dom.childNodes, true);
    var firstImg = findOne(function (element) {
      return element.name === 'img';
    }, dom.childNodes, true);
    setIsFirstImage(!!firstImg);
    var newFirstAccordion = firstAccordion;
    if (firstAccordion) {
      var _firstAccordion$attri;
      var dataJson = (_firstAccordion$attri = firstAccordion.attribs) === null || _firstAccordion$attri === void 0 ? void 0 : _firstAccordion$attri['data-json'];
      try {
        var _firstAccordion$attri2, _firstAccordion$attri3, _accordionList$length;
        var accordionList = JSON.parse(decodeURIComponent((_firstAccordion$attri2 = (_firstAccordion$attri3 = firstAccordion.attribs) === null || _firstAccordion$attri3 === void 0 ? void 0 : _firstAccordion$attri3['data-json']) !== null && _firstAccordion$attri2 !== void 0 ? _firstAccordion$attri2 : ''));
        var accordionItemCount = (_accordionList$length = accordionList === null || accordionList === void 0 ? void 0 : accordionList.length) !== null && _accordionList$length !== void 0 ? _accordionList$length : 0;
        var slicedAccordionItems = accordionList === null || accordionList === void 0 ? void 0 : accordionList.slice(0, MAX_ACCORDION_ITEMS_IN_PREVIEW);
        dataJson = encodeURIComponent(JSON.stringify(slicedAccordionItems));
        setShowGradientForAccordion(isUIOptimisationAccordion && accordionItemCount >= MAX_ACCORDION_ITEMS_IN_PREVIEW);
      } catch (e) {
        console.log('article parse accordion list error', e);
      }
      newFirstAccordion = new Element('accordion-block', _objectSpread(_objectSpread({}, firstAccordion.attribs), {}, {
        expand: 'false',
        'data-json': dataJson
      }), firstAccordion.childNodes);
      replaceElement(firstAccordion, newFirstAccordion);
    }
    if (newFirstAccordion && firstImg) {
      if (compareDocumentPosition(firstImg, newFirstAccordion) & 2) {
        // Node.DOCUMENT_POSITION_PRECEDING
        setIsFirstImage(true);
        return getOuterHTML(firstImg);
      } else {
        return getOuterHTML(newFirstAccordion);
      }
    } else if (newFirstAccordion) {
      return getOuterHTML(newFirstAccordion);
    } else if (firstImg) {
      setIsFirstImage(true);
      return getOuterHTML(firstImg);
    } else {
      return null;
    }
  };
  var onClose = function onClose() {
    onArticleClose === null || onArticleClose === void 0 ? void 0 : onArticleClose();
    if (!controlShowArticle) {
      setShowArticle(false);
    }
    if (articleContentTrackingData) {
      var trackCloseArticleContentData = trackCloseArticleContentDataRef.current;
      var _trackingData = _objectSpread(_objectSpread({}, articleContentTrackingData), {}, {
        view_duration: Math.floor((new Date().getTime() - trackCloseArticleContentData.startTime.getTime()) / 1000),
        article_scrolls: trackCloseArticleContentData.articleScrolls,
        table_scrolls: trackCloseArticleContentData.tableScrolls,
        article_scroll_to_end: trackCloseArticleContentData.articleScrollToEnd ? 0 : 1
      });
      tracker.click({
        trackingsection: TRACKING_SECTION[TRACKING_TYPE.ARTICLE_DETAIL],
        trackingtarget: TRACKING_TARGET.closeArticle,
        data: _objectSpread({}, _trackingData)
      });
    }
  };
  var realText = useMemo(function () {
    return getArticleRealText();
  }, [content]);
  var firstElement = useMemo(function () {
    return getArticleFirstElement();
  }, [content]);
  var isFirstElementAccordion = firstElement === null || firstElement === void 0 ? void 0 : firstElement.includes('<accordion-block');
  var calMaxLines = useMemo(function () {
    return firstElement ? 1 : 2;
  }, [content]);
  var onClickViewMore = function onClickViewMore() {
    changeTrackClosePopupData({
      startTime: new Date(),
      articleScrolls: 0,
      articleScrollToEnd: false
    });
    setShowPopup(true);
  };
  var onClosePopup = function onClosePopup() {
    setShowPopup(false);
  };
  var onClickFaq = function onClickFaq(faq, option) {
    var _props$onClickFaq;
    if (disabledFaq) {
      var _props$onClickDisable;
      (_props$onClickDisable = props.onClickDisabledFaq) === null || _props$onClickDisable === void 0 ? void 0 : _props$onClickDisable.call(props, faq);
      return;
    }
    if (showPopup) {
      setShowPopup(false);
    }
    (_props$onClickFaq = props.onClickFaq) === null || _props$onClickFaq === void 0 ? void 0 : _props$onClickFaq.call(props, faq, option);
  };
  var renderLoadingArticle = function renderLoadingArticle() {
    var _ComponentStatusMappi;
    var NetworkError = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FailToLoad, {
      style: styles['article__error-image']
    }), /*#__PURE__*/React.createElement(RNText, {
      style: styles['article__error-prompt']
    }, failToLoadText, /*#__PURE__*/React.createElement(Pressable, {
      onPress: function onPress() {
        var _props$reloadArticle;
        (reloadTracking === null || reloadTracking === void 0 ? void 0 : reloadTracking.trackingClick) && tracker.click(reloadTracking.trackingClick);
        props === null || props === void 0 ? void 0 : (_props$reloadArticle = props.reloadArticle) === null || _props$reloadArticle === void 0 ? void 0 : _props$reloadArticle.call(props);
      }
    }, /*#__PURE__*/React.createElement(RNText, {
      style: [styles['article__error-prompt'], styles['article__error-prompt-a']]
    }, reloadText))));
    var Loading = /*#__PURE__*/React.createElement(Animated.View, {
      style: {
        transform: [{
          rotate: rotateInterpolation
        }]
      }
    }, /*#__PURE__*/React.createElement(LoadingCircle, {
      style: styles['article__loading-icon']
    }));
    var ArticleIsDeleted = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FailToLoad, {
      style: styles['article__error-image']
    }), /*#__PURE__*/React.createElement(RNText, {
      style: styles['article__error-prompt']
    }, articleDeletedText));
    var ComponentStatusMapping = (_ComponentStatusMappi = {}, _defineProperty(_ComponentStatusMappi, ArticleStatus.ERROR, NetworkError), _defineProperty(_ComponentStatusMappi, ArticleStatus.LOADING, Loading), _defineProperty(_ComponentStatusMappi, ArticleStatus.DELETED, ArticleIsDeleted), _defineProperty(_ComponentStatusMappi, ArticleStatus.FINISH, null), _ComponentStatusMappi);
    return ComponentStatusMapping[status] || NetworkError;
  };
  var handleAccordionItemClick = function handleAccordionItemClick(accordionIndex, accordionItemIndex) {
    setDefaultAccordionIndexInfo([accordionIndex, accordionItemIndex]);
    if (isUIOptimisationAccordion) {
      if (isOldUI) {
        setShowArticle(true);
      } else {
        setShowPopup(true);
      }
    }
  };
  useEffect(function () {
    if (isOldUI && autoPopup && !controlShowArticle && !showArticle) {
      setTimeout(function () {
        setShowArticle(true);
      }, 0);
    }
    Animated.loop(Animated.timing(rotateAnimate, {
      toValue: 1,
      duration: 1000,
      easing: Easing.linear,
      useNativeDriver: true
    })).start();
  }, []);
  useEffect(function () {
    if (!isOldUI && needPopup && !showArticle && exceededMaxHeight) {
      setTimeout(function () {
        setShowPopup(true);
      }, 500);
    }
  }, [exceededMaxHeight]);
  useEffect(function () {
    scrollY === null || scrollY === void 0 ? void 0 : scrollY.addListener(function (animation) {
      var _scrollViewRef$curren;
      (_scrollViewRef$curren = scrollViewRef.current) === null || _scrollViewRef$curren === void 0 ? void 0 : _scrollViewRef$curren.scrollTo({
        y: animation.value,
        animated: true
      });
    });
    return function () {
      return scrollY.removeAllListeners();
    };
  }, []);
  useEffect(function () {
    if (showPopup && isScrollToUnread && scrollHeight > 0) {
      setTimeout(function () {
        // 滚动到指定位置
        Animated.timing(scrollY, {
          toValue: scrollHeight,
          // 滚动到位置
          duration: 400,
          // 动画持续时间
          // easing: Easing.in(Easing.ease),
          easing: Easing.cubic,
          useNativeDriver: true // 使用原生驱动器以提高性能
        }).start();
      }, 1500);
    } else {
      scrollY.setValue(0);
      var element = scrollViewRef.current;
      element === null || element === void 0 ? void 0 : element.scrollTo({
        y: 0,
        animated: true
      });
    }
  }, [showPopup, isScrollToUnread, scrollHeight]);
  useEffect(function () {
    var accordionIndex = defaultAccordionIndexInfo[0];
    var needScrollToAccordion = isUIOptimisationAccordion && accordionIndex > -1;
    if (showPopup && needScrollToAccordion && accordionOffsetTop > 0) {
      setTimeout(function () {
        Animated.timing(scrollY, {
          toValue: accordionOffsetTop,
          duration: 0,
          easing: Easing.cubic,
          useNativeDriver: true
        }).start();
      }, 300);
    } else {
      scrollY.setValue(0);
      var element = scrollViewRef.current;
      element === null || element === void 0 ? void 0 : element.scrollTo({
        y: 0,
        animated: true
      });
    }
  }, [showPopup, defaultAccordionIndexInfo, accordionOffsetTop]);
  useEffect(function () {
    if (isUIOptimisationAccordion) {
      if (isOldUI) {
        if (!showArticle) {
          setDefaultAccordionIndexInfo([-1, -1]);
        }
      } else {
        if (!showPopup) {
          setDefaultAccordionIndexInfo([-1, -1]);
        }
      }
    }
  }, [isUIOptimisationAccordion, isOldUI, showArticle, showPopup]);
  var handleSummaryLayout = function handleSummaryLayout(contentHeight) {
    // 有可能图片未加载出来时 contentHeight 刚好小于 summaryMaxHeight 不到 1
    // 等到全部内容加载好也没能触发 summary 的 layout 事件，这里减 1 处理一下
    if (contentHeight >= summaryMaxHeight - 1) {
      setExceededMaxHeight(true);
      onExceededMaxHeightChange === null || onExceededMaxHeightChange === void 0 ? void 0 : onExceededMaxHeightChange(true);
    } else {
      setExceededMaxHeight(false);
      onExceededMaxHeightChange === null || onExceededMaxHeightChange === void 0 ? void 0 : onExceededMaxHeightChange(false);
    }
  };
  return /*#__PURE__*/React.createElement(View, {
    style: styles[PREFIX]
  }, isOldUI ? /*#__PURE__*/React.createElement(View, null, status === ArticleStatus.FINISH ? /*#__PURE__*/React.createElement(View, _extends({
    style: styles['article-content']
  }, articleTracking === null || articleTracking === void 0 ? void 0 : articleTracking.trackingImpressionProps), /*#__PURE__*/React.createElement(Title, {
    styles: styles['article-title'],
    content: title
  }), realText ? /*#__PURE__*/React.createElement(Text, {
    styles: styles['article-desc'],
    content: realText,
    maxLines: calMaxLines
  }) : null, firstElement ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RichText, {
    webViewKey: webViewKey,
    content: "<div style='overflow: hidden;\n                          text-overflow: ellipsis;\n                          white-space: nowrap;\n                          word-break: break-word;height: 0;'>".concat(realText, "</div>") + firstElement,
    className: "article-first-element ".concat(isUIOptimisationAccordion && isFirstElementAccordion ? 'article-first-element-accordion-optimisation' : ''),
    defaultWidth: getScaledPx(RNStyle.BubbleInnerWidth - 24),
    showMask: isFirstImage || showGradientForAccordion,
    showLoading: false,
    richTextSize: richTextSize,
    onWebViewSizeChange: _onWebViewSizeChange,
    onImageError: props.onImageError,
    onImageLoad: props.onImageLoad,
    isUIOptimisationButton: isUIOptimisationButton,
    accordionOptions: {
      isUIOptimisationAccordion: isUIOptimisationAccordion,
      onAccordionClick: handleAccordionItemClick
    },
    isUIOptimisationTableReview: isUIOptimisationTable,
    haveMinRichTextWidth: haveMinRichTextWidth
  })) : null) : /*#__PURE__*/React.createElement(View, _extends({
    style: styles["article__".concat(status.toLowerCase())]
  }, status === ArticleStatus.ERROR && (reloadTracking === null || reloadTracking === void 0 ? void 0 : reloadTracking.trackingImpressionProps), status === ArticleStatus.DELETED && (deleteTracking === null || deleteTracking === void 0 ? void 0 : deleteTracking.trackingImpressionProps)), /*#__PURE__*/React.createElement(View, {
    style: [styles['article-content'], styles["article__".concat(status.toLowerCase(), "-article-content")]]
  }, renderLoadingArticle())), /*#__PURE__*/React.createElement(Button, {
    disabled: status !== ArticleStatus.FINISH,
    action: {
      func: 'showArticle'
    },
    text: showButtonText || trans(VIEW_ARTICLE_TEXT),
    onClick: function onClick() {
      (articleTracking === null || articleTracking === void 0 ? void 0 : articleTracking.trackingClick) && tracker.click(articleTracking.trackingClick);
      onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick();
      if (!controlShowArticle) {
        setShowArticle(!showArticle);
      }
    },
    styles: {
      containerStyle: styles['button-container']
    }
  }), /*#__PURE__*/React.createElement(PopupArticle, {
    webViewKey: webViewKey,
    active: controlShowArticle ? showArticleByCaller : showArticle,
    title: currentDisplayedTitle ? currentDisplayedTitle : title,
    content: currentDisplayedContent ? currentDisplayedContent : content,
    closeButtonText: closeButtonText,
    onClose: onClose,
    changeTrackCloseArticleContentData: changeTrackCloseArticleContentData,
    articleContentTrackingData: articleContentTrackingData,
    disableSpecialLink: disableSpecialLink,
    showExpandIcon: showExpandIcon,
    onImageError: props.onImageError,
    onImageLoad: props.onImageLoad,
    accordionOptions: {
      isUIOptimisationAccordion: isUIOptimisationAccordion,
      expand: true,
      accordionIndex: defaultAccordionIndexInfo[0],
      accordionItemIndex: defaultAccordionIndexInfo[1]
    },
    isUIOptimisationTable: isUIOptimisationTable,
    haveMinRichTextWidth: haveMinRichTextWidth
  })) : /*#__PURE__*/React.createElement(View, {
    style: styles["".concat(PREFIX, "-wrapper")]
  }, status === ArticleStatus.FINISH ? /*#__PURE__*/React.createElement(View, {
    style: _objectSpread(_objectSpread({}, styles["".concat(PREFIX, "-summary")]), {}, {
      maxHeight: summaryMaxHeight
    })
  }, /*#__PURE__*/React.createElement(RichText, {
    webViewKey: webViewKey,
    content: content,
    defaultWidth: getScaledPx(BubbleInnerWidth - 24),
    showLoading: false,
    richTextSize: richTextSize,
    onWebViewSizeChange: function onWebViewSizeChange(size) {
      _onWebViewSizeChange === null || _onWebViewSizeChange === void 0 ? void 0 : _onWebViewSizeChange(size);
      var contentHeight = size.height;
      handleSummaryLayout(contentHeight);
    },
    gradientOffsetTop: summaryMaxHeight - linearGradientHeight - 6,
    summaryMaxHeight: summaryMaxHeight,
    handleUnreadObjChange: function handleUnreadObjChange(val) {
      setUnreadObj(_objectSpread({
        text: unreadObj === null || unreadObj === void 0 ? void 0 : unreadObj.text
      }, val));
    },
    onImageError: props.onImageError,
    onImageLoad: props.onImageLoad,
    showMask: exceededMaxHeight,
    maskType: MaskType.ArticleNewUI,
    isUIOptimisationButton: isUIOptimisationButton,
    accordionOptions: {
      isUIOptimisationAccordion: isUIOptimisationAccordion,
      onAccordionClick: handleAccordionItemClick
    },
    isUIOptimisationTableReview: isUIOptimisationTable,
    haveMinRichTextWidth: haveMinRichTextWidth,
    richTextTouchEnd: handleRichTextTouchEnd
  })) : /*#__PURE__*/React.createElement(View, {
    style: styles["article__".concat(status.toLowerCase())]
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles['article-content'], styles["article__".concat(status.toLowerCase(), "-article-content")]]
  }, renderLoadingArticle())), exceededMaxHeight && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Pressable, {
    style: styles["".concat(PREFIX, "-btn")],
    onPress: onClickViewMore,
    disabled: status !== ArticleStatus.FINISH
  }, /*#__PURE__*/React.createElement(RNText, {
    style: styles["".concat(PREFIX, "-btn-text")]
  }, viewMoreText), /*#__PURE__*/React.createElement(ArrowDown, {
    style: styles["".concat(PREFIX, "-arrow")]
  }))), /*#__PURE__*/React.createElement(Popup, {
    showCloseIcon: true,
    contentContainerStyle: _objectSpread(_objectSpread(_objectSpread({}, styles["".concat(PREFIX, "-popup-content-container")]), isUIOptimisationTableStyle ? styles["".concat(PREFIX, "-popup-content-container-ui-optimisation-table-modal")] : {}), {}, {
      height: 'auto'
    }),
    contentStyle: styles["".concat(PREFIX, "-popup-content")],
    active: showPopup,
    onClose: onClosePopup,
    contentScrollable: false
  }, /*#__PURE__*/React.createElement(Animated.ScrollView, _extends({
    style: styles["".concat(PREFIX, "-detail-content")],
    ref: scrollViewRef,
    scrollEventThrottle: 16,
    onScrollBeginDrag: function onScrollBeginDrag() {
      return scrollY.stopAnimation();
    },
    onLayout: function onLayout() {
      emitTrackingEvent(ARTICLE_TRACKER_SCOPE);
    },
    onScroll: function onScroll() {
      emitTrackingEvent(ARTICLE_TRACKER_SCOPE);
    },
    scrollEnabled: Platform.OS === 'android' ? scrollEnabled : true,
    overScrollMode: "never" // onTouchStart={onScrollViewTouchStart}
    // onTouchMove={onScrollViewTouchMove}
    // onTouchEnd={onScrollViewTouchEnd}
  }, panResponder.panHandlers), /*#__PURE__*/React.createElement(View, {
    onStartShouldSetResponder: function onStartShouldSetResponder() {
      return true;
    }
  }, /*#__PURE__*/React.createElement(RichTextInWebView, {
    webViewKey: webViewKey,
    content: content,
    onClose: onClosePopup,
    defaultWidth: Dimensions.get('window').width - PopupArticlePaddingHorizontal,
    needScrollToUnread: showPopup && isScrollToUnread,
    unreadObj: unreadObj,
    exceededMaxHeight: exceededMaxHeight,
    handleScroll: function handleScroll(val) {
      setScrollHeight(val);
    },
    articleContentTrackingData: articleContentTrackingData,
    disableSpecialLink: !!disableSpecialLink,
    showExpandIcon: showExpandIcon,
    onImageError: props.onImageError,
    onImageLoad: props.onImageLoad,
    isUIOptimisationButton: isUIOptimisationButton,
    accordionOptions: {
      isUIOptimisationAccordion: isUIOptimisationAccordion,
      expand: true,
      accordionIndex: defaultAccordionIndexInfo[0],
      accordionItemIndex: defaultAccordionIndexInfo[1],
      onAccordionOffsetTopChange: function onAccordionOffsetTopChange(offsetTop) {
        setAccordionOffsetTop(offsetTop);
      }
    },
    isUIOptimisationTableModal: isUIOptimisationTable,
    haveMinRichTextWidth: haveMinRichTextWidth,
    handleDisabledScroll: handleDisabledScroll,
    richTextTouchEnd: handleRichTextTouchEnd
  }), !isSeparate && /*#__PURE__*/React.createElement(FAQList, {
    disabledFaq: disabledFaq,
    PREFIX: PREFIX,
    faqTitle: faqTitle,
    faqIntentList: faqIntentList,
    onClickFaq: onClickFaq,
    trackingData: (_props$componentTrack = props.componentTrackingData) === null || _props$componentTrack === void 0 ? void 0 : _props$componentTrack.faqInDetail,
    styles: _objectSpread({}, styles["".concat(PREFIX, "-faq-container-top12")]),
    isUIOptimisationRecommender: isUIOptimisationRecommender,
    isUIOptimisationTable: isUIOptimisationTable,
    isUIOptimisationTableStyle: isUIOptimisationTableStyle
  }))))));
};